export const normalizeTitle = (titulo: string) => {
    const normalize = titulo.toLowerCase().split(" ").join("");
    return normalize 
}